import React from 'react';
import LocationMap from './LocationMap';
import LocationInfo from './LocationInfo';

export default function LocationSection() {
  return (
    <section className="relative py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          <LocationMap />
          <LocationInfo />
        </div>
      </div>
    </section>
  );
}